import type { InjectionKey } from "vue";
import type { Emitter } from "mitt";
import { TEventsModel } from "~/types";

export const EVENT_BUS_SERVICE_INJECTION_KEY: InjectionKey<
  Emitter<TEventsModel>
> = Symbol("EVENT_BUS_SERVICE");
